import { useTranslation } from 'react-i18next';
import styles from './page-title.module.scss';
import { Typography } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface PageTitleProps {
  title: string,
  subtitle?: string,
  showNoCompanyMessage?: boolean
}

export function PageTitle(props: PageTitleProps) {
  const { t } = useTranslation();

  return (
    <Typography
      variant="h2"
      component="div"
      className="mb-5"
      sx={{ flexGrow: 1 }}>
      {props.showNoCompanyMessage ? <span>{t("pageTitle.noCustomerSelected")}</span> :
        (<span>{props.title} {props.subtitle && <span className='MuiTypography-body3'>{props.subtitle}</span>}</span>)}
    </Typography>
  );
}

export default PageTitle;